import { notifications } from "@mantine/notifications";

export const ErrorToast = (err) => {
    try {
        if (typeof err === 'string') {
            return notifications.show({
                color: 'red',
                position: "bottom-right",
                title: 'Error',
                message: err
            });
        } else {
            let errorDetail = err.response?.data?.detail || "An unexpected error occurred."
            const status = err.response?.status || ''
            if(Array.isArray(errorDetail)){
                errorDetail = errorDetail[0].msg
            }
            return notifications.show({
                color: "red",
                position: "top-right",
                title: `Error${status ? ` - ${status}` : ''}`,
                message: errorDetail
            });
        }
    } catch {
        return notifications.show({
            color: "red",
            position: "top-right",
            title: 'Error - Something went wrong',
            message: "An unexpected error occurred.",
        });
    }
}

export const SuccessToast = ({ message }) => {

    return notifications.show({
        color: "green",
        position: "top-right",
        title: 'Success',
        message: message
    },
    )

}